import { type ReactNode } from 'react'
import { X } from 'lucide-react'
import './selection-action-bar.css'

export interface SelectionActionBarProps {
	selectedCount: number
	onClearSelection: () => void
	actions: Array<{
		label: string
		icon: ReactNode
		onClick: () => void
		variant?: 'default' | 'destructive'
	}>
}

export function SelectionActionBar({
									   selectedCount,
									   onClearSelection,
									   actions,
								   }: SelectionActionBarProps) {
	return (
		<div className="selection-action-bar">
			<div className="selection-action-bar__content">
				<span className="selection-action-bar__count">
					{selectedCount} selected
				</span>

				<div className="selection-action-bar__actions">
					{actions.map((action, index) => (
						<button
							key={index}
							onClick={action.onClick}
							className="selection-action-bar__button"
							data-variant={action.variant || 'default'}
						>
							{action.icon}
							<span>{action.label}</span>
						</button>
					))}

					<button
						onClick={onClearSelection}
						className="selection-action-bar__clear"
						aria-label="Clear selection"
					>
						<X size={18} />
						<span>Clear</span>
					</button>
				</div>
			</div>
		</div>
	)
}
